import { useNavigate } from 'react-router-dom'
import { Props } from '../typings'
import { useCallback } from 'react'
import { UseData } from './useData'
import { useAppDispatch } from '@user/store/hooks'
import { saveRecentSearch } from '@user/store/globalSearch/api'

type HandlersProps = Pick<UseData, 'toggleOpen'> & Props

export function useHandlers(props: HandlersProps) {
  const {
    searchItem: { entityId, entityType },
    onRowClick,
    toggleOpen,
  } = props

  const navigate = useNavigate()
  const dispatch = useAppDispatch()

  const handleItemClick = useCallback(
    (e) => {
      e.stopPropagation()
      let url: string = ''
      switch (entityType.toLowerCase()) {
        case 'lead':
          url = `/leads/${entityId}`
          break
        case 'opportunity':
          url = `/opportunities/${entityId}`
          break
        case 'draftlead':
          url = `/leads/addLead?draftId=${entityId}`
          break
      }
      dispatch(
        saveRecentSearch({ entityType: entityType.toLowerCase(), entityId }),
      )
      if (url && url.length > 0) {
        navigate(url)
      }
      if (onRowClick) {
        onRowClick(props.searchItem)
      }
    },
    [dispatch, entityId, entityType, navigate, onRowClick, props.searchItem],
  )

  const toggleCollapse = useCallback(
    (e) => {
      e.stopPropagation()
      toggleOpen()
    },
    [toggleOpen],
  )

  return { handleItemClick, toggleCollapse }
}
